export enum EWorkshopAppUrls {
  WORKSHOP_APP = 'workshop-app',
  IDAHO = 'idaho',
  CITIES = 'cities',
  WORKSHOP_CITIES = 'workshop-event/location/cities',
}
